// ─── MSP Belt Standards ────────────────────────────────────────────────────────
export const BELT_LEVELS = ['yellow', 'green', 'blue', 'purple', 'brown', 'black'];
export const BELT_COLORS = {
    yellow: '#f1c40f',
    green: '#2ecc71',
    blue: '#3498db',
    purple: '#9b59b6',
    brown: '#8B4513',
    black: '#ecf0f1',
};

export const DRILLS = [
    {
        id: '3x2',
        name: '3×2 Drill',
        subtitle: '3 yards',
        description: 'Draw and fire 3 body shots (A-zone) then 2 head shots',
        yardage: 3,
        parTimes: {
            yellow: 4.0, green: 3.5,
            blue: 3.0, purple: 2.5, brown: 2.15, black: 2.0
        },
        shots: [
            { zone: 'body', index: 0 },
            { zone: 'body', index: 1 },
            { zone: 'body', index: 2 },
            { zone: 'head', index: 0 },
            { zone: 'head', index: 1 },
        ],
    },
    {
        id: '7yard',
        name: '7-Yard Draw',
        subtitle: '7 yards',
        description: 'Draw and fire 1 shot center mass (A-zone)',
        yardage: 7,
        parTimes: {
            yellow: 2.0, green: 1.75,
            blue: 1.5, purple: 1.3, brown: 1.1, black: 1.0
        },
        shots: [{ zone: 'body', index: 0 }],
    },
    {
        id: 'bill',
        name: 'Bill Drill',
        subtitle: '7 yards',
        description: 'Draw and fire 6 shots center mass (A-zone)',
        yardage: 7,
        parTimes: {
            yellow: 4.0, green: 3.5,
            blue: 3.0, purple: 2.5, brown: 2.15, black: 2.0
        },
        shots: [
            { zone: 'body', index: 0 },
            { zone: 'body', index: 1 },
            { zone: 'body', index: 2 },
            { zone: 'body', index: 3 },
            { zone: 'body', index: 4 },
            { zone: 'body', index: 5 },
        ],
    },
    {
        id: '25yard',
        name: '25-Yard Shot',
        subtitle: '25 yards',
        description: 'Draw and fire 1 shot center mass (A-zone)',
        yardage: 25,
        parTimes: {
            yellow: 2.75, green: 2.5,
            blue: 2.25, purple: 2.0, brown: 1.65, black: 1.5
        },
        shots: [{ zone: 'body', index: 0 }],
    },
];

// Full test: run all 4 drills in sequence. Belt only if ALL pass at same level.
export const FULL_DRILL = {
    id: 'full',
    name: 'MSP Full Test',
    subtitle: 'All 4 drills',
    description: 'Run all four MSP standards back-to-back. You must pass every drill at the same belt level to earn it.',
    isFullTest: true,
};

export const ALL_DRILLS = [...DRILLS, FULL_DRILL];

// ─── Belt Eval ────────────────────────────────────────────────────────────────
export function evaluateBelt(drill, timeSeconds, parTimes) {
    if (timeSeconds === null) return null;
    const p = parTimes ?? drill.parTimes;
    if (timeSeconds <= p.black) return 'black';
    if (timeSeconds <= p.brown) return 'brown';
    if (timeSeconds <= p.purple) return 'purple';
    if (timeSeconds <= p.blue) return 'blue';
    if (timeSeconds <= p.green) return 'green';
    if (timeSeconds <= p.yellow) return 'yellow';
    return 'miss';
}

// Full test: highest belt where ALL 4 drills are within par.
export function evaluateFullBelt(times, drills, effectiveParFn) {
    for (const belt of [...BELT_LEVELS].reverse()) {
        const allPassed = drills.every((d, i) => times[i] != null && times[i] <= effectiveParFn(d)[belt]);
        if (allPassed) return belt;
    }
    return 'miss';
}
